import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import constants from 'contest/data/constants';

export default function DesignCanvasOverlay({ design }) {
    if (
        design.activeUserRole === constants.DESIGN_ROLE_CUSTOMER &&
        design.isWithdrawn &&
        !design.isDeleted
    ) {
        return (
            <div className="design-canvas__overlay">
                <div className="design-canvas-overlay">
                    <div className="design-canvas-overlay__inner">
                        <span className="design-canvas-overlay__title">
                            <FormattedMessage id="withdrawn_design_overlay_title" />
                        </span>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

DesignCanvasOverlay.propTypes = {
    design: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/design-canvas-overlay.jsx